// extracted by mini-css-extract-plugin
export var nav = "nav-module--nav--70d4d";